<template lang="pug">
div
  .page-hero
  .container.page-container
    h1.title {{ companyName }}
    h2.subtitle {{ $t("labels.business_id") }}: {{ companyBusinessId }}
    UiCard
      template(v-if="!signed && !failed")
        template(v-if="!inProgress")
          UiCardSection(padding="2xl")
            p Thanks for choosing finance.rocks.
            p Please accept our terms of service so we can set up your environment.
            p After you press Integrate, go and get yourself a hot cup of coffee.
            p When your back, you will have more info in your email (can take a few minutes to get you started) :)
            p
              a(href="/terms_of_service") Terms of service

            UiStack
              UiStackItem(fill)
                UiCheckbox(v-model="confirmed") {{ $t("netvisor_integration.confirm") }}
              UiStackItem
                UiButton(
                  variant="primary"
                  @click="confirmAgreement"
                  :disabled="!confirmed"
                ) {{ $t("netvisor_integration.submit") }}
        template(v-else)
          UiCardSection(padding="display")
            UiStack(justify="center")
              UiSpinner(
                variant="primary"
                type="grow"
              )

      template(v-else-if="signed")
        UiCardSection(padding="display")
          UiStack(align="center")
            UiStackItem(fill)
              | Terms accepted. Please wait we setup your environment.
            UiStackItem
              UiButton(
                variant="primary"
                @click="continueUsage"
              ) {{ $t("actions.continue") }}

      template(v-else-if="failed")
        UiCardSection(padding="display")
          p {{ $t("netvisor_integration.error_occurred") }}: {{ errorMessage }}
</template>

<script>
import { mapGetters } from "vuex";
import ApiUser from "@/api/user.js";

export default {
  data() {
    return {
      inProgress: false,
      signed: false,
      failed: false,
      errorMessage: "",
      confirmed: false,
      companyName: "",
      companyBusinessId: "",
    };
  },

  computed: {
    ...mapGetters(["user"]),
  },

  mounted() {
    this.companyName =
      user.current_integration_attempt.company_name ?? "Unknown";
    this.companyBusinessId =
      user.current_integration_attempt.company_business_id ?? "Unknown";
  },

  methods: {
    continueUsage() {
      window.location.href = "/";
    },
    confirmAgreement() {
      this.inProgress = true;
      this.$store.dispatch("confirmAgreement");
      ApiUser.finalizeIntegration()
        .then((resp) => {
          if (resp.data.success) {
            this.signed = true;
            this.inProgress = false;
          } else {
            this.failed = true;
            this.errorMessage = resp.data.message;
            this.inProgress = false;
          }
        })
        .catch((err) => {
          this.failed = true;
          this.errorMessage = err.response.data.error;
          this.inProgress = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheet/_variables.scss";
@import "@/assets/stylesheet/_mixins.scss";

.page-container {
  max-width: 820px;
}

.subtitle {
  font-size: 1.35rem;
  color: var(--bb-gray-500);
}
</style>
